package com.eladfinish.bible.contest.screens.browse.contentOfChapter.ui

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.enter_deceased_name
import com.eladfinish.bible.contest.ui.components.buttons.ItemButtonText
import dev.icerock.moko.resources.compose.stringResource

/**
 * Tehilim 119 of the "שונות" tab: the button that enters the name its verses spell, pinned above
 * [content] (nothing until a name is entered, then the verses) so the name can be changed at any time.
 */
@Composable
internal fun WithDeceasedNameButton(
    onEnterNameClick: () -> Unit,
    content: @Composable () -> Unit,
) {
    Column(Modifier.fillMaxSize()) {
        ItemButtonText(
            modifier = Modifier
                .align(Alignment.CenterHorizontally)
                .padding(horizontal = 16.dp, vertical = 8.dp),
            text = stringResource(SharedRes.strings.enter_deceased_name),
            borderWidth = 0,
            onClick = onEnterNameClick,
        )
        Box(
            Modifier
                .fillMaxWidth()
                .weight(1f),
        ) {
            content()
        }
    }
}
